import types from "./types";

const apiSubmissionsInitialState = {
  apis: [],
  fetchingApis: false,
  errorMessage: ""
};

const apiSubmissions = (state = apiSubmissionsInitialState, action) => {
  switch (action.type) {
    case types.API_GET_REQUEST_PROVIDERS:
      return {
        ...state,
        fetchingApis: true,
        errorMessage: ""
      };
    case types.API_GET_RECEIVE_PROVIDERS:
      return {
        ...state,
        apis: action.response,
        fetchingApis: false
      };
    case types.API_GET_ERROR_PROVIDERS:
      return {
        ...state,
        fetchingApis: false,
        errorMessage: action.apierror.message
      };
    default:
      return state;
  }
};

export default apiSubmissions;
